import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldInputModule } from 'src/app/components/field-input/field-input.module';
import { CollapsedNamesComponent } from 'src/app/components/hour-control/collapsed-names/collapsed-names.component';
import { HourControlComponent } from 'src/app/components/hour-control/hour-control.component';
import { GenericModule } from 'src/app/generic/generic.module';
import { PhoneNumberPipe } from 'src/app/pipes/phone-number.pipe';
import { ValueInArrayPipe } from 'src/app/pipes/value-in-array.pipe';
import { RealisationRowButtonsComponent } from '../../components/hour-control/realisation-row/buttons/realisation-row-buttons.component';
import { RealisationRowCountsTotalComponent } from '../../components/hour-control/realisation-row/counts-total/realisation-row-counts-total.component';
import { RealisationRowNameComponent } from '../../components/hour-control/realisation-row/name/realisation-row-name.component';
import { RealisationRowPrefixComponent } from '../../components/hour-control/realisation-row/prefix/realisation-row-prefix.component';
import { RealisationRowComponent } from '../../components/hour-control/realisation-row/realisation-row.component';
import { RealisationRowTimeProjectComponent } from '../../components/hour-control/realisation-row/time-project/realisation-row-time-project.component';
import { LocationFormatPipe } from '../../trackline/pages/trackline-planning/location-format.pipe';
import { CheckHoursFilterPipe } from '../check-hours/check-hours-filter.pipe';
import { DoesNotMatchDriverPipe } from '../check-hours/does-not-match-driver.pipe';
import { IsTraveltimePipe } from '../check-hours/is-traveltime.pipe';
import { IsWorktimePipe } from '../check-hours/is-worktime.pipe';
import { NotApprovablePipe } from '../check-hours/not-approvable.pipe';
import { NotEditablePipe } from '../check-hours/not-editable.pipe';
import { AddMaterialDialogComponent } from './add-material-dialog/add-material-dialog.component';
import { DayReportButtonsComponent } from './day-report-buttons/day-report-buttons.component';
import { DayReportFormComponent } from './day-report-form/day-report-form.component';
import { DayReportHourControlComponent } from './day-report-hour-control/day-report-hour-control.component';
import { DayReportMaterialenComponent } from './day-report-materialen/day-report-materialen.component';
import { DayReportNavButtonsComponent } from './day-report-nav-buttons/day-report-nav-buttons.component';
import { DayReportRoutingModule } from './day-report-routing.module';
import { DayReportStateService } from './day-report-state.service';
import { DayReportComponent } from './day-report.component';

@NgModule({
    declarations: [
        DayReportComponent,
        DayReportMaterialenComponent,
        AddMaterialDialogComponent,
        DayReportButtonsComponent,
        DayReportFormComponent,
        DayReportHourControlComponent,
        DayReportNavButtonsComponent,
        HourControlComponent,
        RealisationRowComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        DayReportRoutingModule,
        GenericModule,
        FieldInputModule,
        PhoneNumberPipe,
        MatButtonModule,
        MatCheckboxModule,
        MatIconModule,
        MatDialogModule,
        MatInputModule,
        MatSelectModule,
        MatListModule,
        MatRadioModule,
        LocationFormatPipe,
        MatTooltipModule,
        IsTraveltimePipe,
        IsWorktimePipe,
        NotApprovablePipe,
        NotEditablePipe,
        CheckHoursFilterPipe,
        ValueInArrayPipe,
        DoesNotMatchDriverPipe,
        CollapsedNamesComponent,
        RealisationRowButtonsComponent,
        RealisationRowCountsTotalComponent,
        RealisationRowNameComponent,
        RealisationRowPrefixComponent,
        RealisationRowTimeProjectComponent,
    ],
    exports: [HourControlComponent],
    providers: [DayReportStateService],
})
export class DayReportModule {}
